// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"334":"0b1f22d6","460":"1bf218a9"}[chunkId] + ".chunk.js";
};